<template>
  <div>
    <List
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" @click="goto(item)">
        <div class="list-item">
          <div>
            <p class="list-item-title">{{item.title}}</p>
            <p class="list-item-time">{{item.time}}</p>
          </div>
          <div class="list-item-state"></div>
          <div class="list-item-more">
            <span class="num" v-if="item.type == 1">+{{item.price}}</span>
            <span class="num" style="color:#F9647D" v-if="item.type == 2">-{{item.price}}</span>
          </div>
        </div>
      </div>
    </List>
  </div>
</template>
<script>
import { List } from "vant";

export default {
  components: {
    List,
  },
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      page: 1,
    };
  },
  methods: {
    onLoad() {
      this.t = this.$route.query.t;
      this.getList();
      this.page++;
    },
    goto(item){
      if (item.oid == 0) return;
      this.$router.push({ query: { item: item }, path: "commissionDetails" });
    },
    getList() {
      let data = {page: this.page}
      if(this.t){
        data.type = this.t
      }
      this.api.myDetailed(data).then((res) => {
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .list-item {
    margin: 0 0.24rem;
    height: 1.3rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    .list-item-title {
      font-size: 0.3rem;
      font-weight: 400;
      color: #666666;
    }
    .list-item-time {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
    }
    .list-item-state {
      flex: 1;
      text-align: right;

      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin-right: 0.58rem;
    }
    .list-item-more {
      .num {
        font-size: 0.3rem;
        font-weight: 400;
        color: #ffa380;
        margin-right: 0.12rem;
      }
      i {
        font-size: 12px;
        color: #cccccc;
      }
    }
  }
</style>
